import { Link } from "react-router-dom";

const Personalize = () => {
  return (
    <div className="rounded-[12px] w-fit bg-white p-6">
      <div className="flex items-center gap-2">
        <h1 className="text-[22px] font-bold">Personalized for you</h1>
        <img
          src="/assets/money/investmentOptions.png"
          alt="investment options"
          className="w-fit h-[11.5px] object-cover"
        />
      </div>

      <div className="bg-[linear-gradient(57deg,#090909_1%,#292929_98%)] text-white p-6 rounded-[10px] w-[511px] relative overflow-hidden mt-4">
        <img
          src="/assets/money/cc.webp"
          alt="credit card"
          className="absolute -right-3 w-[230px] top-[20px]"
        />
        <h2 className="text-[22px] font-bold w-1/2 leading-[1.2]">
          Credit card recommendations
        </h2>
        <h4 className="text-[15px] w-[220px] mt-4">
          Discover top-rated credit cards, compare benefits, and find the
          perfect match for your lifestyle.
        </h4>
        <Link to="https://www.money.onepercentclub.io/card/">
          <button className="bg-[#007aff] py-[8px] px-[16px] text-[15px] rounded-full leading-[1.33] mt-[24px] font-bold">
            Know more
          </button>
        </Link>
      </div>
    </div>
  );
};

export default Personalize;
